import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MarkupContainer } from "./Markup.styles";
var Markup = function(param) {
    var content = param.content, isHidden = param.isHidden, element = param.element;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ _jsx(MarkupContainer, {
        hidden: isHidden || false,
        dangerouslySetInnerHTML: {
            __html: content
        },
        as: element
    });
};
Markup.displayName = "raw";
export { Markup };
